<template>
  <div v-html="viewValue"></div>
</template>

<script>
export default {
  name: "HdsIdBox",
  props: {
    value: {
      type: String,
      required: false
    },
  },
  computed: {
    viewValue() {
      if (this.value) {
        const m = /^([^:]+):(.+)$/.exec(this.value)
        if (m) {
          const id1 = m[1].substr(0, 8);
          const id2 = m[1].substr(8);
          const version = m[2];
          return `<span class="id">${id1}<span class="invisible">${id2}</span></span> <span class="version_prefix">v</span><span class="version">${version}</span>`
        } else {
          return `Invalid ID: ${this.value}`
        }
      } else {
        return "";
      }
    },
  },
}
</script>

<style scoped>
>>> .invisible {
  font-size:0;
  line-height:0
}
</style>
